import _ from 'lodash';
import * as ActionType from '../../constants/actionType';

const initialState = {};

export default function undoRedoState(state = initialState, action = '') {
  const past = state[action.keyName] ? state[action.keyName].past : [];
  const present = state[action.keyName] ? state[action.keyName].present : null;
  const future = state[action.keyName] ? state[action.keyName].future : [];
  const max = 9;

  switch (action.type) {
    case ActionType.UNDO_REDO_STATE_UNDO_ITEM: {
      const previous = past[past.length - 1];
      const newPast = past.slice(0, past.length - 1);

      return {
        ...state,
        [action.keyName]: {
          past: newPast,
          present: previous,
          future: [present, ...future],
        },
      };
    }
    case ActionType.UNDO_REDO_STATE_REDO_ITEM: {
      const next = future[0];
      const newFuture = future.slice(1);

      return {
        ...state,
        [action.keyName]: {
          past: [...past, present],
          present: next,
          future: newFuture,
        },
      };
    }
    case ActionType.UNDO_REDO_STATE_NEW_ITEM: {
      const oldPast = past.length >= max ? [...past.slice(past.length - max, past.length)] : past;
      let newOld = present;
      if (action.oldData) {
        newOld = action.oldData;
      }

      return {
        ...state,
        [action.keyName]: {
          past: present ? [...oldPast, newOld] : [...oldPast],
          present: action.data,
          future: [],
        },
      };
    }
    case ActionType.UNDO_REDO_STATE_RESTORE_ITEM:
      return {
        ...state,
        [action.keyName]: {
          past: action.past,
          present: action.past[action.past.length - 1],
          future: [],
        },
      };
    case ActionType.UNDO_REDO_UPDATE_PRESENT_ITEM:
      return {
        ...state,
        [action.keyName]: {
          ...state[action.keyName],
          present: action.data,
        },
      };
    case ActionType.UNDO_REDO_STATE_CLEAR_ITEM:
      return _.omit(state, [action.keyName]);
    case ActionType.UNDO_REDO_STATE_RESTORE_ALL:
      return action.state;
    case ActionType.UNDO_REDO_STATE_RESET:
      return initialState;
    default:
      return state;
  }
}
